var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
export var StyledMediaCarousel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin: 0 auto;\n  perspective: 400px;\n  height: ", "px;\n  width: ", "px;\n  transform-style: preserve-3d;\n  @media (max-width: 769px) {\n    width: 70vw;\n    height: calc(\n      70vw * ", "\n    );\n    perspective: 100px;\n  }\n"], ["\n  position: relative;\n  margin: 0 auto;\n  perspective: 400px;\n  height: ", "px;\n  width: ", "px;\n  transform-style: preserve-3d;\n  @media (max-width: 769px) {\n    width: 70vw;\n    height: calc(\n      70vw * ", "\n    );\n    perspective: 100px;\n  }\n"])), function (_a) {
    var $slideHeight = _a.$slideHeight;
    return $slideHeight;
}, function (_a) {
    var $slideWidth = _a.$slideWidth;
    return $slideWidth;
}, function (_a) {
    var $slideWidth = _a.$slideWidth, $slideHeight = _a.$slideHeight;
    return $slideHeight / $slideWidth;
});
export var StyledMediaSlide = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  transform: rotateY(calc(", " * 40deg))\n    scaleY(calc(1 + ", " * -0.1))\n    translateZ(calc(", " * -30rem))\n    translateX(\n      calc(", " * -8rem)\n    );\n\n  ", "\n  filter: blur(calc(", " * 0.5rem));\n  transition: all 0.3s ease-out;\n  @media (max-width: 768px) {\n    width: 70vw;\n    height: calc(\n      70vw * ", "\n    );\n    filter: blur(calc(", " * 0.3rem));\n    filter: blur(calc(", " * 0.3rem));\n    transform: rotateY(calc(", " * 20deg))\n      scaleY(calc(1 + ", " * -0.1))\n      translateZ(calc(", " * -25vw))\n      translateX(\n        calc(", "* -8rem)\n      );\n    ", ";\n  }\n  @media (max-width: 550px) {\n    transform: rotateY(calc(", " * 20deg))\n      scaleY(calc(1 + ", " * -0.1))\n      translateZ(calc(", " * -25vw))\n      translateX(\n        calc(", " * -3rem)\n      );\n\n    ", "\n  }\n"], ["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  transform: rotateY(calc(", " * 40deg))\n    scaleY(calc(1 + ", " * -0.1))\n    translateZ(calc(", " * -30rem))\n    translateX(\n      calc(", " * -8rem)\n    );\n\n  ", "\n  filter: blur(calc(", " * 0.5rem));\n  transition: all 0.3s ease-out;\n  @media (max-width: 768px) {\n    width: 70vw;\n    height: calc(\n      70vw * ", "\n    );\n    filter: blur(calc(", " * 0.3rem));\n    filter: blur(calc(", " * 0.3rem));\n    transform: rotateY(calc(", " * 20deg))\n      scaleY(calc(1 + ", " * -0.1))\n      translateZ(calc(", " * -25vw))\n      translateX(\n        calc(", "* -8rem)\n      );\n    ", ";\n  }\n  @media (max-width: 550px) {\n    transform: rotateY(calc(", " * 20deg))\n      scaleY(calc(1 + ", " * -0.1))\n      translateZ(calc(", " * -25vw))\n      translateX(\n        calc(", " * -3rem)\n      );\n\n    ", "\n  }\n"])), function (_a) {
    var $slideHeight = _a.$slideHeight;
    return $slideHeight;
}, function (_a) {
    var $slideWidth = _a.$slideWidth;
    return $slideWidth;
}, function (_a) {
    var $offset = _a.$offset;
    return $offset;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $offset = _a.$offset, $absOffset = _a.$absOffset;
    return $offset / $absOffset;
}, function (_a) {
    var $isActive = _a.$isActive;
    return $isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      transform: none;\n    "], ["\n      transform: none;\n    "])));
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $slideWidth = _a.$slideWidth, $slideHeight = _a.$slideHeight;
    return $slideHeight / $slideWidth;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $offset = _a.$offset;
    return $offset;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $offset = _a.$offset, $absOffset = _a.$absOffset;
    return $offset / $absOffset;
}, function (_a) {
    var $isActive = _a.$isActive;
    return $isActive && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        transform: none;\n      "], ["\n        transform: none;\n      "])));
}, function (_a) {
    var $offset = _a.$offset;
    return $offset;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $absOffset = _a.$absOffset;
    return $absOffset;
}, function (_a) {
    var $offset = _a.$offset, $absOffset = _a.$absOffset;
    return $offset / $absOffset;
}, function (_a) {
    var $isActive = _a.$isActive;
    return $isActive && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        transform: none;\n      "], ["\n        transform: none;\n      "])));
});
var StyledNavigationButton = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #c4c4c4;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n  z-index: 99;\n"], ["\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #c4c4c4;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n  z-index: 99;\n"])));
export var StyledPrevArrow = styled(StyledNavigationButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  left: -15rem;\n  border-right: none;\n  border-top: none;\n  @media (max-width: 768px) {\n    left: -15%;\n  }\n"], ["\n  left: -15rem;\n  border-right: none;\n  border-top: none;\n  @media (max-width: 768px) {\n    left: -15%;\n  }\n"])));
export var StyledNextArrow = styled(StyledNavigationButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  right: -15rem;\n  border-left: none;\n  border-bottom: none;\n  @media (max-width: 768px) {\n    right: -15%;\n  }\n"], ["\n  right: -15rem;\n  border-left: none;\n  border-bottom: none;\n  @media (max-width: 768px) {\n    right: -15%;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
